<div class="elevation-profile-button-container ">
  @if (ref_hasRouteToCreateProfile()) {
    <button matMiniFab disableRipple="true" class="map-control-button neutral-button" [ngClass]="{'active': isChartShown()}"
      id="elevationProfileButton"
      (click)="traceService.toggleElevationProfile()"
      [matTooltip]="isChartShown() ?('trace.hide-profile-tooltip' | translate):'trace.show-profile-tooltip' | translate"
      matTooltipPosition="left">
      <mat-icon fontSet="ngi" fontIcon="elevation-profile"></mat-icon>
    </button>
  }
  <!-- <button class="map-control" *ngIf="ref_hasRouteToCreateProfile()" mat-icon-button color="none" [ngClass]="{'active': isChartShown()}" (click)="traceService.toggleElevationProfile()" [matTooltip]="isChartShown()?'trace.hide-profile-tooltip':'trace.show-profile-tooltip' | translate" matTooltipPosition="below">
  <mat-icon fontSet="ngi" fontIcon="elevation-profile"></mat-icon>
</button> -->
</div>

<!-- <div class="legend-button-container">
<button mat-mini-fab aria-label="Legend" color="none" [ngClass]="{'active': isOpen}" (click)="toggle()"
  [matTooltip]="'legendTxt.showlegend' | translate" matTooltipPosition="left">
  <mat-icon fontSet="ngi" fontIcon="tree-deciduous"></mat-icon>
</button>
</div> -->
<!--
<div style="z-index: 999;position: fixed;top:460px;padding:15px;border-radius: 6px;left:10px;background: rgb(255, 217, 0);">
  <form>
    <input type="text" value="1" #interval>
    <button type="button" mat-flat-button (click)="setMyInterval(interval.value)">interval</button>
  </form>
  interval : {{interval_yup}}<br>
  tickInterval : {{tick_interval_yup}}<br>
  <br>
    showRestore: {{showRestore}}
    <br><br>
    <button type="button" mat-flat-button (click)="sjappi()">reset zoom</button>
    <button type="button" mat-flat-button (click)="setToolbox()">toolbox on/off</button>
    <button type="button" mat-flat-button (click)="hopla()">toolbox</button>

  </div>
  -->
  <div class="elevationProfile" id="elevationProfile" #elevationProfile [ngClass]="{'shown': isChartShown(), 'building': isBuildingProfile()}">
    <div class="spinner-wrapper">
      <mat-spinner color="accent" [diameter]="15"></mat-spinner>
    </div>
    <button matIconButton type="button" class="close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>

  @if (fetchError()) {

  <div class="fetchError">
    {{'general.http-errors.client-side-error' | translate}}
    <br/><br/>
    <button matButton (click)="retryAfterFetchElevationsError()"><mat-icon>load</mat-icon>{{'general.install' | translate}}</button>
  </div>

  } @else {

  <!-- class chart is used in the pdf-dialog component -->
  <!--, pointerSize:42 <div echarts [initOpts]="{ height:'150px', renderer:'svg'}" [options]="options" [merge]="mergeOptions" (chartInit)="onChartInit($event)" class="chart"></div> -->
  <div echarts
    [initOpts]="{devicePixelRatio: 1, height:'150px', width:'auto', renderer:'canvas', useCoarsePointer:true }"
    [options]="options" [merge]="mergeOptions()" (chartInit)="onChartInit($event)" class="chart tt-an"></div>

  }

    <!-- <div echarts [initOpts]="{devicePixelRatio: 8, height:'150px', width:'auto', renderer:'canvas'}" [options]="options" [merge]="mergeOptions" (chartInit)="onChartInit($event)" class="chart"></div>  -->
    <!-- <div>{{ summary }}</div> -->

  </div>